module.exports = __webpack_public_path__ + "static/textinput-placeholder-dont-d1d310b5daf5aea95df39387580746d7.png";